import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useContext } from 'react';
import classnames from 'classnames';
import { Url, USER_PROFILE_POSTS_SUB_PATHS, USER_PROFILE_SHOP_SUB_PATHS, USER_PROFILE_SECTION_PATHS } from '@wix/da-url';
import { BiData, BiContextProvidedValue } from '@wix/da-bi/pkg/events';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { ResourceType } from '../../../types/resource';
import { BiContext } from '@wix/da-bi/pkg/BiLogger.context';
import { useRestrictToLoggedIn } from '../../../utils/hooks/useRestrictToLoggedIn';
import { isGroup } from '../../helpers';
import s from './BasicUserLink.scss';
function getLinkUrl({ username }, linkTo) {
    switch(linkTo){
        case 'gallery':
            return Url.userGalleryLink({
                username,
                gallectionType: 'gallery'
            });
        case 'favourites':
            return Url.userGalleryLink({
                username,
                gallectionType: 'collection'
            });
        case 'posts':
            return Url.userPostsLink({
                username,
                subPath: USER_PROFILE_POSTS_SUB_PATHS.ALL
            });
        case 'shop':
            return Url.userShopPath(username, USER_PROFILE_SHOP_SUB_PATHS.ALL);
        case 'about':
            return Url.userLink(username, USER_PROFILE_SECTION_PATHS.ABOUT);
        case 'home':
        default:
            return Url.userLink(username);
    }
}
export const BasicUserLink = (_param)=>{
    var { user, user: { type, usericon, username, userId, useridUuid }, linkTo, children, className, biData } = _param, rest = _object_without_properties(_param, [
        "user",
        "user",
        "linkTo",
        "children",
        "className",
        "biData"
    ]);
    const { isLoggedIn } = useRestrictToLoggedIn();
    const biContext = useContext(BiContext);
    if (!isLoggedIn && biContext.component === 'art' && biContext.view === 'submission' && biContext.sectionname !== 'author_popup') {
        linkTo = 'gallery';
    }
    const userType = type === 'super group' ? 'super' : type;
    const biEventData = BiData(_object_spread_props(_object_spread({
        itemid: user.userId,
        typeid: isGroup(user) ? ResourceType.GROUP : ResourceType.USER
    }, biData), {
        evid: 101,
        sectionname: BiContextProvidedValue
    }));
    return /*#__PURE__*/ React.createElement(BiLink, _object_spread({
        biData: biEventData,
        "data-username": username,
        "data-icon": usericon,
        "data-usersymbol": type,
        "data-isgroup": isGroup(user) ? '1' : '0',
        "data-userid": userId,
        "data-useruuid": useridUuid,
        href: getLinkUrl(user, linkTo),
        className: classnames('user-link', s['user-link'], s[`link-${userType}`], className)
    }, rest), children);
};
BasicUserLink.displayName = 'BasicUserLink';
export default BasicUserLink;

//# sourceMappingURL=BasicUserLink.js.map